import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { useAuthStore } from '@/features/auth/store/auth-store'
import { PRIVACY_URL, SERVICE_URL } from '@/features/discover/data/config'
import { RegisterEmailForm } from './email-register-form'
import { RegisterPhoneForm } from './phone-register-form'

export function RegisterForm() {
  const { setView } = useAuthStore((s) => s.authView)
  const [registerMode, setRegisterMode] = useState<'phone' | 'email'>('phone')

  const renderContent = () => {
    if (registerMode === 'phone') {
      return (
        <div className='grid gap-4'>
          <RegisterPhoneForm />
          <Button
            variant='link'
            className='text-muted-foreground w-full font-normal'
            onClick={() => setRegisterMode('email')}
          >
            使用邮箱注册
          </Button>
        </div>
      )
    }

    return (
      <div className='grid gap-4'>
        <RegisterEmailForm />
        <Button
          variant='link'
          className='text-muted-foreground w-full font-normal'
          onClick={() => setRegisterMode('phone')}
        >
          使用手机号注册
        </Button>
      </div>
    )
  }

  return (
    <div className='flex flex-col gap-6'>
      <div className='flex flex-col items-center gap-2 text-center'>
        <h1 className='text-foreground text-2xl font-semibold tracking-tight'>
          {registerMode === 'phone' ? '手机号注册' : '邮箱注册'}
        </h1>
        <p className='text-muted-foreground text-sm'>开启您的创意之旅</p>
      </div>

      {renderContent()}

      <div className='text-muted-foreground px-8 text-center text-sm'>
        注册代表您同意元点引擎的
        <a
          className='text-foreground hover:text-primary underline underline-offset-4'
          href={`${PRIVACY_URL}`}
          target='_blank'
          rel='noopener noreferrer'
        >
          隐私政策
        </a>
        和
        <a
          className='text-foreground hover:text-primary underline underline-offset-4'
          href={`${SERVICE_URL}`}
          target='_blank'
          rel='noopener noreferrer'
        >
          服务协议
        </a>
      </div>

      <div className='text-muted-foreground text-center text-sm'>
        已经有账号了？{' '}
        <Button
          variant='link'
          className='text-primary p-0 hover:underline'
          onClick={() => setView('login')}
        >
          回登录
        </Button>
      </div>
    </div>
  )
}
